import FrameSearch from './FrameSearch'

export * from './FrameSearch'

export default FrameSearch
